import mutators from '@/models'

const fields = [
  {
    name: 'N. Referência',
    field: 'reference',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 3,
    type: 'string',
    rules: {
      required: false
    }
  },
  {
    name: 'Estado',
    field: 'status',
    visible: true,
    sortable: false,
    filterable: true,
    filterWidth: 3,
    type: 'string',
    rules: {
      required: false
    }
  },
  {
    name: 'Cliente',
    field: 'client',
    visible: true,
    sortable: false,
    filterable: true,
    filterWidth: 3,
    type: 'string',
    rules: {
      required: false
    }
  },
  {
    name: 'Tipo',
    field: 'type',
    visible: true,
    sortable: false,
    filterable: true,
    filterWidth: 3,
    type: 'string',
    rules: {
      required: false
    }
  },
  {
    name: 'Data Inserção',
    field: 'created_at',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'date',
    translatable: false,
    rules: {
      required: false
    }
  },
  {
    name: 'Data Última Atualização',
    field: 'updated_at',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'date',
    translatable: false,
    rules: {
      required: false
    }
  },
  {
    name: 'Data Eliminação',
    field: 'deleted_at',
    visible: false,
    sortable: false,
    filterable: false,
    type: 'date',
    translatable: false,
    rules: {
      required: false
    }
  },
]

const rules = mutators.rules(fields)
const empty = mutators.empty(fields)
const filters = mutators.filters(fields)

export default {
  fields,
  rules,
  empty,
  filters
}
